/* START GENAI@GHCOPILOT */
import { error, invalidParam } from 'common/errors';
import { pushUctpInit, setInitData as gampSetInitData } from 'common/gamp';
import { markEnd, markStart } from 'common/instrumentation';
import initialize from 'orch-communicator/external/initialize';
import { InitData, InitDataVSB } from 'types/vsb-sdk/init';
import { InitDataModel } from 'vsb-sdk/schemas/init';
/* END GENAI@GHCOPILOT */

function validate(rawInitData: unknown): InitDataVSB {
  if (typeof rawInitData !== 'object' || rawInitData === null) {
    throw error('DPA_ID_MISSING', `The "dpaId" parameter is missing.`);
  }

  const result = InitDataModel.safeParse(rawInitData);

  if (!result.success) {
    const { issues } = result.error;

    if (
      issues.some(issue => issue.path.includes('dpaId')) ||
      issues.some(issue => issue.path.includes('dpaData'))
    ) {
      throw error('DPA_ID_MISSING', `The "dpaId" parameter is missing.`, issues);
    }

    throw invalidParam(issues);
  }

  return result.data;
}

export default async (rawInitData: unknown) => {
  /* START GENAI@GHCOPILOT */
  markStart('vsb_merchant_pov_initialize');
  gampSetInitData(rawInitData as InitData);
  const validatedInitData = validate(rawInitData as InitDataVSB);
  await initialize(validatedInitData as InitDataVSB);
  markEnd('vsb_merchant_pov_initialize');
  /* END GENAI@GHCOPILOT */
  pushUctpInit();
  return {};
};
